import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer.jsx";
import HomeBrandSlices from "../components/HomeBrandSlices.jsx";

// /brands — the brand index. The landing page brand slices, stacked as
// straight vertical bands instead of on the diagonal, each one opening its
// brand on /brand through the same state.targetBrand hand-off the header
// brands menu and the sidebar use. Order, images and the live-stock rule all
// come from HomeBrandSlices, so this page can never disagree with /brand.
export default function BrandsPage() {
  const navigate = useNavigate();
  return (
    <div className="featured-page brands-index-page">
      <section className="brands-index-page__wall" aria-label="Brands">
        <HomeBrandSlices
          variant="bands"
          labels
          onSelect={(name) => navigate("/showcase", { state: { targetBrand: name } })}
        />
      </section>
      <Footer />
    </div>
  );
}
